import {NgModule} from '@angular/core';
import {TripAssetListComponent} from './trip-asset-list.component';
import {BaseAssociatedEntityListModule} from '../../shared/base-associated-entity-list/base-associated-entity-list.module';
import {AssetListItemModule} from '../../shared/asset-list-item/asset-list-item.module';
import {SharedModule} from '../../shared/shared.module';

export const MODULE_DECLARATIONS = [TripAssetListComponent];

export const MODULE_IMPORTS = [
  AssetListItemModule,
  BaseAssociatedEntityListModule,
  SharedModule,
];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: [TripAssetListComponent],
})
export class TripAssetListModule {}
